import { ErrorMessage, useFormikContext } from 'formik'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Card, Row, Col, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons'
import { CreateApplicationFormValues } from './CreateApplication'
import CreateApplicationContact from './CreateApplicationContact'

const CreateApplicationContacts = (): React.ReactElement | null => {
  const { t } = useTranslation(['createApplication', 'common'])
  const { values, setFieldValue } = useFormikContext<CreateApplicationFormValues>()

  if (!values.ssnValid || !values.town) {
    return null
  }

  return (
    <Card className="mb-2">
      <Card.Body>
        <Row>
          <Col>
            <h4>{t('adstandendur')}</h4>
          </Col>
        </Row>
        <Row>
          <Col>
            {values.contacts.map((_, i) => (
              <CreateApplicationContact key={`contact-${i}`} index={i} />
            ))}
            <ErrorMessage name="contacts">
              {(msg) =>
                typeof msg === 'string' ? <div className="invalid-feedback d-block text-left">{msg}</div> : null
              }
            </ErrorMessage>
            {values.contacts.length < 4 && (
              <Button
                type="button"
                variant="secondary"
                className="float-right"
                onClick={(e) =>
                  setFieldValue('contacts', [
                    ...values.contacts,
                    {
                      ssn: '',
                      name: '',
                      email: '',
                      mobile: '',
                    },
                  ])
                }
              >
                <FontAwesomeIcon icon={faPlusCircle} /> {t('baetaVidAdstandanda')}
              </Button>
            )}
          </Col>
        </Row>
      </Card.Body>
    </Card>
  )

  /*




            <b-btn type="button" className="float-right" @click.prevent="addContact" v-if="form.contacts.length <= 3">
              <i className="fas fa-plus-circle"></i>
              {{ $t('baetaVidAdstandanda') }}
            </b-btn>
          </Col>
        </Row>
  */
}

export default CreateApplicationContacts
